import React, { useEffect, useState } from "react";
import { FaStar, FaSearch } from "react-icons/fa";
import { HiOutlineArrowRight } from "react-icons/hi";
import { RiBookmarkLine, RiShareBoxLine } from "react-icons/ri";
import { FaGraduationCap } from "react-icons/fa6";
import { PiStarFourFill } from "react-icons/pi";
import { BsDot } from "react-icons/bs";
import SummaryApi from '../common'
import noimage from "../asset/noimage.png"
import { useNavigate } from "react-router-dom";
import { useAuth } from "../helpers/AuthContext"; // Import useAuth
import { FaBookmark } from "react-icons/fa";
import Swal from "sweetalert2";
import { FaArrowLeft } from "react-icons/fa";
const CarrerCourses = () => {
  const navigate = useNavigate();
  const [coursesData, setCoursesData] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const coursesPerPage = 6;
 const [savedCourseIds, setSavedCourseIds] = useState([]);
  const { studentId, studentName, setStudentName, logout } = useAuth();
  const student_id = studentId;

const allCategories = [
  { value: "Begginer", label: "Beginner" },
  { value: "Intermediate", label: "Intermediate" },
  { value: "Advanced", label: "Advanced" }
];
useEffect(() => {
  window.scrollTo(0, 0);
}, []);

  useEffect(() => {
    fetch(SummaryApi.getActiveCarrerCourses.url)
      .then((res) => res.json())
      .then((data) => {
        if (data.status && data.data) {
          setCoursesData(data.data);
        }
      })
      .catch((err) => console.error("API error:", err));
  }, []);
  useEffect(() => {
    if (student_id) {
      fetch(SummaryApi.getSavedcourseStudentId.url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ student_id }),
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.status && data.data) {
            setSavedCourseIds(data.data); // Save entire saved course objects
          }
        })
        .catch((err) => console.error("Failed to fetch saved courses:", err));
    }
  }, [student_id]);

  const handleSaveCourse = (course_id) => {
    if (!student_id) {
      Swal.fire({
        icon: "warning",
        title: "Please log in first",
        text: "You need to be logged in to save courses.",
      });
      return;
    }

    if (savedCourseIds.find((c) => c.course_id === course_id)) {
      Swal.fire({
        icon: "info",
        title: "Already Saved",
        text: "This course is already in your saved list.",
      });
      return;
    }

    fetch(SummaryApi.SaveCourseToStudent.url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ student_id, course_id }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status) {
          setSavedCourseIds((prev) => [
            ...prev,
            { course_id, saved_course_id: data.saved_course_id },
          ]);

          Swal.fire({
            icon: "success",
            title: "Course Saved",
            text: "The course has been added to your saved list.",
            timer: 1500,
            showConfirmButton: false,
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Save Failed",
            text: data.message || "Failed to save the course.",
          });
        }
      })
      .catch((err) => {
        console.error("Error saving course:", err);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Something went wrong while saving the course.",
        });
      });
  };

  const handleDeleteSavedCourse = (course_id) => {
    const savedCourse = savedCourseIds.find((c) => c.course_id === course_id);
    if (!savedCourse) return;

    fetch(SummaryApi.DeleteSavedCourse.url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ saved_course_id: savedCourse.saved_course_id }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status) {
          setSavedCourseIds((prev) =>
            prev.filter((c) => c.course_id !== course_id)
          );

          Swal.fire({
            icon: "success",
            title: "Course Removed",
            text: "The course has been removed from your saved list.",
            timer: 1500,
            showConfirmButton: false,
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Remove Failed",
            text: data.message || "Failed to remove the saved course.",
          });
        }
      })
      .catch((err) => {
        console.error("Error deleting saved course:", err);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Something went wrong while removing the saved course.",
        });
      });
  };
// REPLACE your current filteredCourses with this:
const filteredCourses = coursesData.filter((course) => {
  const rawLevel = course.diffculty_level?.trim();
  const level = rawLevel === "Begginer" ? "Begginer" : rawLevel;

  const matchesCategory =
    selectedCategories.length === 0 ||
    selectedCategories.includes(level);

  const matchesSearch =
    !searchQuery ||
    course.course_title?.toLowerCase().includes(searchQuery.toLowerCase());

  return matchesCategory && matchesSearch;
});
  const indexOfLastCourse = currentPage * coursesPerPage;
  const indexOfFirstCourse = indexOfLastCourse - coursesPerPage;
  const currentCourses = filteredCourses.slice(
    indexOfFirstCourse,
    indexOfLastCourse
  );
  const totalPages = Math.ceil(filteredCourses.length / coursesPerPage);

  useEffect(() => {
    setCurrentPage(1);
  }, [selectedCategories, searchQuery]);

  return (
  <div className="dark:bg-gray-900 relative">
  {/* Back Button - Only show on responsive devices (hidden on lg and larger) */}
  <button
    onClick={() => window.history.back()}
    className="fixed top-24 left-4 z-50 flex items-center justify-center w-12 h-12 bg-white rounded-full shadow-lg hover:shadow-xl transition-all border border-gray-200 dark:bg-gray-800 dark:border-gray-700 lg:hidden"
    aria-label="Go back"
  >
    <FaArrowLeft className="text-2xl text-[#103b6b] dark:text-white" />
  </button>
      <section className="bg-[#0E3A6D] dark:bg-gray-800 text-white py-20 text-center rounded">
        <h1 className="text-4xl md:text-5xl font-bold mb-6">Career Courses</h1>
        <p className="text-lg md:text-xl max-w-3xl mx-auto">
          Explore our wide range of premium courses designed by industry experts
          to help you
          <br className="hidden md:block" />
          advance your career with cutting-edge skills and certifications
        </p>
      </section>

      {/* 🔍 Search + Sort Section */}
      <div className="bg-white dark:bg-gray-800 px-4 py-6 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
 <div className="w-full md:w-2/3">
      <div className="relative">
        <input
          type="text"
          placeholder="Search career courses..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          className="w-full border border-gray-300 dark:border-gray-600 rounded-full py-3 px-5 pr-12 focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white dark:bg-gray-700 text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400"
        />
        <span className="absolute right-4 top-2/4 transform -translate-y-1/2 text-gray-400 dark:text-gray-500">
          <FaSearch className="w-5 h-5" />
        </span>
      </div>
    </div>

          {/* <div className="w-full md:w-1/3 flex items-center justify-between md:justify-end">
            <span className="text-gray-600 dark:text-gray-300 text-sm">
              Showing {filteredCourses.length} results
            </span>
            <div className="ml-4 relative">
              <select className="border border-gray-300 dark:border-gray-600 dark:bg-gray-700 dark:text-white rounded-full px-4 py-1 text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500">
                <option value="newest">Newest</option>
                <option value="popular">Most Popular</option>
                <option value="rating">Highest Rated</option>
              </select>
            </div>
          </div> */}
        </div>
      </div>

      <div className="py-12 px-6 sm:px-6 lg:px-8 dark:bg-gray-900">
        <div className="mx-auto flex flex-col lg:flex-row gap-8">
          {/* Filter Sidebar */}
          <div className="w-full lg:w-1/4">
            <h3 className="text-xl font-bold text-[#1c3664] dark:text-white mb-4">Filter</h3>
            <h4 className="text-md font-semibold text-[#1c3664] dark:text-white mb-2">Difficulty Level</h4>
{allCategories.map((item) => (
  <div key={item.value} className="mb-2">
    <label className="inline-flex items-center">
      <input
        type="checkbox"
        className="form-checkbox text-blue-600 dark:text-blue-500"
        checked={selectedCategories.includes(item.value)}
        onChange={() =>
          setSelectedCategories((prev) =>
            prev.includes(item.value)
              ? prev.filter((c) => c !== item.value)
              : [...prev, item.value]
          )
        }
      />
      <span className="ml-2 text-[#1c3664] dark:text-white">
        {item.label}
      </span>
    </label>
  </div>
))}
          </div>

          {/* Courses Grid */}
          <div className="w-full lg:w-3/4 grid grid-cols-1 md:grid-cols-3 gap-8">
            {currentCourses.map((course) => (
              <div
                key={course.course_id}
                className="bg-white dark:bg-gray-800 rounded-lg shadow-xl overflow-hidden group hover:shadow-2xl transition-all duration-300"
              >
                {/* Course Image */}
                <div className="relative">
                  <img
                    className="w-full h-48 object-cover"
                    src={
                      course.course_image1
                        ? `${SummaryApi.Images.url.replace(
                  "api",
                  ""
                )}${course.course_image1.replace("/api", "")}`
                        : noimage
                    }
                    alt={course.course_title}
                  />
                  <div className="absolute top-[73%] left-4 bg-gray-100 dark:bg-gray-700 text-blue-700 dark:text-blue-300 px-3 rounded-full flex items-center py-3">
                    <PiStarFourFill className="w-4 h-4 mr-1 text-yellow-500" />
                    <span className="text-[14px] text-[#1c3664] dark:text-white font-medium">
                      Professional Certificate
                    </span>
                  </div>
                </div>

                {/* Course Content */}
                <div className="p-6">
                  <h3 className="text-xl font-bold text-[#1c3664] dark:text-white mb-2 group-hover:text-[#100F36] dark:group-hover:text-blue-300 transition-colors duration-300">
                    {course.course_title}
                  </h3>

                  <div className="flex items-center text-sm text-gray-600 dark:text-gray-300 mb-4">
                    <div className="flex items-center text-yellow-500 font-semibold mr-4 bg-yellow-50 dark:bg-yellow-900/30 px-3 py-1 rounded-full">
                      <FaStar className="w-4 h-4 mr-1" />
                      {course.rating}
                    </div>
                    <div className="flex items-center space-x-2 ml-auto">
                                          {savedCourseIds.find(
                                            (c) => c.course_id === course.course_id
                                          ) ? (
                                            <FaBookmark
                                              className="w-6 h-6 text-green-600 dark:text-green-400 cursor-pointer"
                                              title="Remove Saved Course"
                                              onClick={() =>
                                                handleDeleteSavedCourse(course.course_id)
                                              }
                                            />
                                          ) : (
                                            <RiBookmarkLine
                                              className="w-6 h-6 text-gray-400 dark:text-gray-500 hover:text-blue-600 dark:hover:text-blue-400 cursor-pointer"
                                              title="Save Course"
                                              onClick={() => handleSaveCourse(course.course_id)}
                                            />
                                          )}
                    
                                          <RiShareBoxLine className="w-6 h-6 text-gray-400 dark:text-gray-500 hover:text-blue-600 dark:hover:text-blue-400 cursor-pointer" />
                                        </div>
                  </div>

                  {/* Duration Placeholder */}
                  <div className="flex items-center justify-between bg-blue-50 dark:bg-blue-900/30 border border-blue-100 dark:border-blue-800 rounded-lg p-3 mb-6">
                    <div className="flex items-center">
                      <FaGraduationCap className="w-6 h-6 text-blue-700 dark:text-blue-300 mr-2" />
                      <span className="text-blue-700 dark:text-blue-300 font-semibold text-base">
                        Duration
                      </span>
                    </div>
                    <span className="text-blue-700 dark:text-blue-300 font-bold text-lg">
                      {course.course_duration || "N/A"}
                    </span>
                  </div>

                  {/* Learn List */}
                  <div className="mt-6">
                    <h4 className="font-bold text-[#1c3664] dark:text-white mb-2">Course Details</h4>
                    <ul className="text-sm text-[#1c3664] dark:text-gray-300 space-y-1">
                      <li className="flex items-start">
                        <BsDot className="w-5 h-5 text-gray-500 dark:text-gray-400 flex-shrink-0 mt-0.5" />
                      <span>Total Lessons: {course.total_lessons || "N/A"}</span>
                      </li>
                      <li className="flex items-start">
                        <BsDot className="w-5 h-5 text-gray-500 dark:text-gray-400 flex-shrink-0 mt-0.5" />
                   <span>Level: {course.diffculty_level === "Begginer" ? "Beginner" : course.diffculty_level || "Not specified"}</span>
                      </li>
                      <li className="flex items-start">
                        <BsDot className="w-5 h-5 text-gray-500 dark:text-gray-400 flex-shrink-0 mt-0.5" />
                        <span>
                          Language: {course.language_instruction || "N/A"}
                        </span>
                      </li>
                    </ul>
                  </div>

                  {/* View Details Button */}
                  <div className="mt-8">
                    <button
                      onClick={() => {
    const encodedId = btoa(course.course_id.toString());
    navigate(`/all-courses/${encodedId}`);
  }}
                     className="w-full text-white font-semibold py-3 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 transition-colors duration-300 flex items-center justify-center bg-[#1C3664] dark:bg-blue-700 hover:bg-blue-800 dark:hover:bg-blue-600">
                      View Details
                      <HiOutlineArrowRight className="w-4 h-4 ml-2" />
                    </button>
                  </div>
                </div>
              </div>
            ))}

            {filteredCourses.length === 0 && (
              <div className="col-span-full text-center text-gray-500 dark:text-gray-400">
                No courses found for selected filters.
              </div>
            )}
          </div>

         
        </div>
         {/* Pagination Controls */}
          {filteredCourses.length > coursesPerPage && (
            <div className="col-span-full flex justify-center mt-8 space-x-4">
              <button
                onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                disabled={currentPage === 1}
                className={`px-4 py-3 rounded-full font-semibold ${
                  currentPage === 1
                    ? "bg-gray-200 dark:bg-gray-700 text-gray-500 dark:text-gray-400 cursor-not-allowed"
                    : "bg-blue-900 dark:bg-blue-700 hover:bg-blue-800 dark:hover:bg-blue-600 text-white"
                }`}
              >
                Prev
              </button>

              <span className="px-4 py-3 bg-blue-100 dark:bg-blue-900/30 text-blue-800 dark:text-blue-300 font-medium rounded-full">
                Page {currentPage} of {totalPages}
              </span>

              <button
                onClick={() =>
                  setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                }
                disabled={currentPage === totalPages}
                className={`px-4 py-3 rounded-full font-semibold ${
                  currentPage === totalPages
                    ? "bg-gray-200 dark:bg-gray-700 text-gray-500 dark:text-gray-400 cursor-not-allowed"
                    : "bg-blue-900 dark:bg-blue-700 hover:bg-blue-800 dark:hover:bg-blue-600 text-white"
                }`}
              >
                Next
              </button>
            </div>
          )}
      </div>
    </div>
  );
};

export default CarrerCourses;